import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchListDG = createAsyncThunk(
  "DesignGroupNameList/fetchListDG",
  async (cmpdetail, { rejectWithValue }) => {

    try {
      const result = await GET(`/design_group/${cmpdetail?.key}`);
      return result?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message)
    }
  }
);

const DesignGroupNameListSlice = createSlice({
  name: "DesignGroupNameList",
  initialState: {
    result: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchListDG.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchListDG.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.result = action.payload;
      })
      .addCase(fetchListDG.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default DesignGroupNameListSlice.reducer;
